<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel">
    <iot-model-points-group-form ref="realForm" @close="close" @ok="submitCallback" :disabled="disableSubmit"/>
  </j-modal>
</template>

<script>

  import IotModelPointsGroupForm from './IotModelPointsGroupForm'

  export default {
    name: 'IotModelPointsGroupModal',
    components: {
      IotModelPointsGroupForm
    },
    data() {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods:{
      add (checkedPointList) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(checkedPointList);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      copy (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.copy(record);
        })
      },
      close () {
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.$emit('ok');
        this.close()
      }
    }
  }
</script>

<style scoped>


</style>